import { render, staticRenderFns } from "./_slug.vue?vue&type=template&id=a2631564&scoped=true&"
import script from "./_slug.vue?vue&type=script&lang=js&"
export * from "./_slug.vue?vue&type=script&lang=js&"
import style0 from "./_slug.vue?vue&type=style&index=0&id=a2631564&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2631564",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a2631564')) {
      api.createRecord('a2631564', component.options)
    } else {
      api.reload('a2631564', component.options)
    }
    module.hot.accept("./_slug.vue?vue&type=template&id=a2631564&scoped=true&", function () {
      api.rerender('a2631564', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "pages/tokens/_slug.vue"
export default component.exports